if (!customElements.get('number-counter')) {
  class NumberCounter extends HTMLElement {
    constructor() {
      super();
      this.counterSelectors = {
        counter: '[main-counter]',
        counterDisplay: '[counter-counts]'
      };
      this.initCounter();
    }

    initCounter() {
      this.counter = this.querySelector(this.counterSelectors.counter);
      this.counterDisplay = this.querySelector(this.counterSelectors.counterDisplay);
      const maxNumber = parseInt(this.counter.dataset.max);

      if (!isNaN(maxNumber)) {
        let currentNumber = 0;
        let step = 1;

        if (maxNumber >= 1000 && maxNumber < 10000) {
          step = 50;
        } else if (maxNumber >= 10000) {
          step = 100;
        }

        const interval = 10; // Adjust this value based on how fast you want the counter to increment

        const counterInterval = setInterval(() => {
          if (currentNumber <= maxNumber) {
            const formattedNumber = currentNumber.toString().padStart(maxNumber.toString().length, '0');
            this.counterDisplay.textContent = formattedNumber;
            currentNumber += step;
          } else {
            clearInterval(counterInterval);
          }
        }, interval);
      }
    }
  }

  customElements.define('number-counter', NumberCounter);

}